import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-cancel-course-dialog',
    templateUrl: './cancel-course-dialog.component.html',
    styleUrls: ['./cancel-course-dialog.component.scss'],
})
export class CancelCourseDialogComponent implements OnInit {
    @Input()
    title: string;

    @Input()
    description: string;

    private _formGroup: FormGroup;

    get formGroup(): FormGroup {
        return this._formGroup;
    }

    constructor(public dialogRef: MatDialogRef<CancelCourseDialogComponent>, private _fb: FormBuilder) {}

    ngOnInit(): void {
        this._formGroup = this._fb.group({
            comment: [''],
        });
    }

    save(): void {
        this.dialogRef.close({ data: this._formGroup.get('comment').value });
    }
}
